import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})

/* Types */
export const SET_CONTACT_DATA = 'SET_CONTACT_DATA'

export const PERSIST_CONTACT_DATA = 'PERSIST_CONTACT_DATA'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case SET_CONTACT_DATA:
			return new Immutable.Map(action.dataObj)
		case PERSIST_CONTACT_DATA:
			return state.set('persisted', action.persisted)
		default:
			return state;
	}
};

/* Action Creators */

export const getContactData = (form) => {
	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getContactData',
			method: "POST",
			data: form,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {

			let domFiscal, domCorreo, domicilios = response.data.datosContacto.domicilios, dataObj = {}

			if (domicilios && domicilios.direccion) {
				domFiscal = domicilios.direccion.filter((d)=>{return (d.tipoDomicilio === "1")})[0]
				domCorreo = domicilios.direccion.filter((d)=>{return (d.tipoDomicilio === "2")})[0]

				dataObj = {
					idDomicilio: domFiscal.idDomicilio ,
					state: parseInt(domFiscal.estado.clave[0].$) ,
					estado: [{id: parseInt(domFiscal.estado.clave[0].$), valor: domFiscal.estado.descripcion}] ,
					city: parseInt(domFiscal.ciudad.clave[0].$) ,
					ciudad: [{id: parseInt(domFiscal.ciudad.clave[0].$), valor: domFiscal.ciudad.descripcion}] ,
					town: parseInt(domFiscal.delegacionMunicipio.clave[0].$) ,
					municipio: [{id: parseInt(domFiscal.delegacionMunicipio.clave[0].$), valor: domFiscal.delegacionMunicipio.descripcion}] ,
					colony: parseInt(domFiscal.colonia.clave[0].$) ,
					//colonia: [{id: parseInt(domFiscal.colonia.clave[0].$), valor: domFiscal.colonia.descripcion}],
					colonia: [{id: parseInt(domFiscal.colonia.clave[0].$), colonia: domFiscal.colonia.descripcion}],
					street: domFiscal.calle ,
					numberExt: domFiscal.numeroExterior ,
					numberInt: domFiscal.numeroInterior ,
					cp: parseInt(domFiscal.codigoPostal.clave[0].$) ,
					street1: domFiscal.entreCalle1 ,
					street2: domFiscal.entreCalle2 ,
					reference: domFiscal.referencia,
					persisted: false
				}

			}

			if (domCorreo) {
				let dataObjMail = {
					mailToggle: 'true',
					mailIdDomicilio: domCorreo.idDomicilio,
					mailState: parseInt(domCorreo.estado.clave[0].$),
					mailEstado: [{id: parseInt(domCorreo.estado.clave[0].$), valor: domCorreo.estado.descripcion}] ,
					mailCity: parseInt(domCorreo.ciudad.clave[0].$),
					mailCiudad: [{id: parseInt(domCorreo.ciudad.clave[0].$), valor: domCorreo.ciudad.descripcion}] ,
					mailTown: parseInt(domCorreo.delegacionMunicipio.clave[0].$) ,
					mailMunicipio: [{id: parseInt(domCorreo.delegacionMunicipio.clave[0].$), valor: domCorreo.delegacionMunicipio.descripcion}] ,
					mailColony: parseInt(domCorreo.colonia.clave[0].$) ,
					mailColonia: [{id: parseInt(domCorreo.colonia.clave[0].$), colonia: domCorreo.colonia.descripcion}],
					mailStreet: domCorreo.calle ,
					mailNumberExt: domCorreo.numeroExterior ,
					mailNumberInt: domCorreo.numeroInterior ,
					mailCp: parseInt(domCorreo.codigoPostal.clave[0].$) ,
					mailStreet1: domCorreo.entreCalle1 ,
					mailStreet2: domCorreo.entreCalle2 ,
					mailReference: domCorreo.referencia
				}
				dataObj = { ...dataObj, ...dataObjMail }
			}

			dispatch({type: SET_CONTACT_DATA, dataObj })
			dispatch(isLoading(false));

			return response.data
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const setContactData = (form) => {

	let formRes = {
		idDonataria: form.idDonataria,
		datosContacto: {
			domicilios: {
				mismoDomicilioCorrespondencia: form.mailToggle === 'false',
				direccion: [
					{
						idDomicilio: form.idDomicilio,
						tipoDomicilio: 1,
						calle: form.street,
						numeroExterior: form.numberExt,
						numeroInterior: form.numberInt,
						codigoPostal: form.cp,
						entreCalle1: form.street1,
						entreCalle2: form.street2,
						referencia: form.reference,
						colonia: form.colony,
						delegacionMunicipio: form.town,
						estado: form.state,
						ciudad: form.city
					}
				]
			}
		}
	}

	if(form.mailIdDomicilio || form.mailToggle === 'true') {
		formRes.datosContacto.domicilios.direccion.push({
			idDomicilio: form.mailIdDomicilio,
			tipoDomicilio: 2,
			calle: form.mailStreet,
			numeroExterior: form.mailNumberExt,
			numeroInterior: form.mailNumberInt,
			codigoPostal: form.mailCp,
			entreCalle1: form.mailStreet1,
			entreCalle2: form.mailStreet2,
			referencia: form.mailReference,
			colonia: form.mailColony,
			delegacionMunicipio: form.mailTown,
			estado: form.mailState,
			ciudad: form.mailCity
		})
	}

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/setContactData',
			method: "POST",
			data: formRes,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then( (response) => {
			dispatch(isLoading(false));
			dispatch({ type: PERSIST_CONTACT_DATA, persisted: true })
			dispatch({ type: PERSIST_CONTACT_DATA, persisted: false })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}




// WEBPACK FOOTER //
// ./src/modules/Grantees/Register/ContactData.js